import { gql } from '@apollo/client';

export const GET_INDEXED_EVM_NFT_BY_TOKEN_ID_QUERY = gql`
  query GetIndexedEvmNFTByTokenId($data: GetIndexedEvmNFTByTokenIdInput!) {
    getIndexedEvmNFTByTokenId(data: $data) {
      tokenId
      tokenType
      name
      description
      tokenUri
      image {
        pngUrl
      }
      metadata {
        image
        description
        attributes {
          max_value
          trait_type
          value
        }
        name
        animation_url
      }
      structuredAttributes
      owner
      balance
      contract {
        address
        name
      }
      equippedWearables {
        avatarId
        templateId
        tokenId
      }
      totalTokens
      distinctOwners
    }
  }
`;
